import { render, staticRenderFns } from "./addGoods.vue?vue&type=template&id=5451c813"
import script from "./addGoods.vue?vue&type=script&lang=js"
export * from "./addGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5451c813')) {
      api.createRecord('5451c813', component.options)
    } else {
      api.reload('5451c813', component.options)
    }
    module.hot.accept("./addGoods.vue?vue&type=template&id=5451c813", function () {
      api.rerender('5451c813', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/retrievalOrder/components/addGoods.vue"
export default component.exports